import { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import copy from 'copy-to-clipboard';

import { openModal } from 'reducers/modalReducer';
import { MODAL_TYPES } from 'view/ModalManager';

// import OutboundLink from 'components/OutboundLink';

import StandardModal from 'modals/StandardModal';
import Spinner from 'components/Spinner';

const FDNYReportModal = ({ options }) => {
	const dispatch = useDispatch();
	const { address, bin, isLoading } = useSelector((state) => ({
		address: state.property?.propertyData?.address,
		bin: state.property?.propertyData?.bin,
		isLoading: state.property?.isLoading,
	}));

	const propertyAddress = options?.address || address;
	const propertyBin = options?.bin || bin;

	const [isCopied, setIsCopied] = useState(false);

	const copyBin = () => {
		copy(propertyBin);
		setIsCopied(true);
	};

	// let url="https://fires.fdnycloud.org/CitizenAccess/Report/ReportParameter.aspx?module=&reportID=984&reportType=LINK_REPORT_LIST";
	let url =
		'https://fires.fdnycloud.org/CitizenAccess/Report/ReportParameter.aspx?module=&reportID=1423&reportType=LINK_REPORT_LIST';

	// const openReport = () => {
	// 	window.open(url, '_blank');
	// }

	let openIframeModal = () => {
		dispatch(openModal(MODAL_TYPES.IFRAME, { url, title: 'FDNY Report' }));
	};

	return (
		<StandardModal
			title={'FDNY Report'}
			size="md"
			confirmText="Access Report"
			onConfirm={openIframeModal}
			closeOnOutsideClick
			noFooterClose
		>
			{isLoading ? (
				<Spinner />
			) : (
				<div>
					<h6 className="">{propertyAddress}</h6>
					<div className="mb-3">
						<div className="form-group">
							<label>BIN</label>

							<div className="input-group">
								<input
									type="text"
									className="form-control"
									value={propertyBin}
									disabled
								/>
								<button
									className={`btn btn-${isCopied ? 'success' : 'primary'}`}
									onClick={copyBin}
								>
									{isCopied ? (
										<i className="bi bi-check me-2" />
									) : (
										<i className="bi bi-clipboard-data me-2" />
									)}
									{isCopied ? 'BIN Copied' : 'Copy BIN'}
								</button>
							</div>
						</div>
					</div>
					<div className="mb-3 fs-6">
						<button
							className="btn-hyperlink text-left"
							onClick={openIframeModal}
						>
							FDNY Report
						</button>
						{/*<OutboundLink
							url={url}
							label={"FDNY Report"}
						/>*/}
					</div>
				</div>
			)}
		</StandardModal>
	);
};

export default FDNYReportModal;
